// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"dd29c4b0","337":"3c5b1266","450":"8c72ab46","455":"fe4744a1","757":"e47d74dd"}[chunkId] + ".chunk.js";
};